<template>
    <div
        class="selectedSymptom_wrap"
        :style="defaultHeight !== undefined && {height:defaultHeight}"
    >
        <KvTable :items="selectedSymptom" class="selectedSymptom"/>
        <KvTable :items="selectedSymptomImage" class="selectedSymptom"/>
    </div>
</template>
<script>
    import KvTable from '@/components/Table/kvTable';
    export default {
        components : {KvTable},
        props : ['selectedScheduleProps', 'patientTotalInfoProps', 'windowRefProps', 'defaultHeight'],
        computed: {
            selectedSymptom() {
              return [
                {
                  index: 0,
                  keyTitle: this.$t('symptom'),
                  keyType: '',
                  class: '',
                  keyRange: [],
                  values: '',
                  parentClass: ''
                },
                {
                  index: 1,
                  keyTitle: '',
                  keyType: 'DefaultInfoInput',
                  parentClass: '',
                  class: '',
                  keyRange: [],
                  values: this.selectedScheduleProps?.scheduleSymptoms ? this.selectedScheduleProps?.scheduleSymptoms : this.$t('alert.no_symptoms_entered')
                }
              ];
            },
            selectedSymptomImage() {
              return [
                {
                  index: 0,
                  keyTitle: this.$t('patient.info.image'),
                  keyType: '',
                  class: '',
                  keyRange: [],
                  values: '',
                  parentClass: ''
                },
                {
                  index: 1,
                  keyTitle: '',
                  keyType: 'ImagePreview',
                  parentClass: 'photo_area_height',
                  class: '',
                  keyRange: [],
                  values: this.selectedScheduleProps.schedulePhotoList,
                  width: '50px',
                  height: '50px',
                  sliderId: this.selectedScheduleProps.seqSchedule,
                  sliderTitle: `${this.patientTotalInfoProps.patientInfo.patientInfoName}/
                            ${this.selectedScheduleProps?.scheduleStartDatetime ?
                      this.moment(this.selectedScheduleProps.scheduleStartDatetime).locale(this.$t('country')).format('lll') :
                      this.moment(this.selectedScheduleProps.scheduleExpectStartDatetime).locale(this.$t('country')).format('lll')}`,
                  window: this.windowRefProps
                }
              ];
            }
        }
    }
</script>
<style lang="scss">
    .selectedSymptom_wrap {
        height: calc(var(--app-height) - 555px);
        display: block;
        overflow: auto;
        .selectedSymptom {
            &.table-container {
                height : unset !important;
                padding: 10px 0;
            }
            &.table-container:first-child {
                border-top: none !important;
                margin-top: 0px !important;
            }
        }
    }
</style>